import React, { useEffect } from 'react'
import { Button, Typogaphy } from 'vnetwork-ui'
import { Controller, useForm } from 'react-hook-form'
import { DayOffReject } from '@/modules/Dayoffs/types/payload'
import { rejectDayOff } from '@/modules/Dayoffs/services'
import toast from 'react-hot-toast'
import { IPermissionProps } from '@/types/shared'
import { DayOffResponse } from '@/modules/Dayoffs/types/response'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface DayOffFormProps extends IPermissionProps {
    onClose?: () => void
    dayOff: DayOffResponse
    refetch: () => void
}
const RejectFeedbackForm: React.FC<DayOffFormProps> = ({
    dayOff,
    refetch,
    onClose,
}) => {
    const {
        mutateAsync: checkRequireActionRejectMutation,
        isPending: isPendingRequireRejectAction,
    } = useMutationWithHandler(
        {
            mutationFn: rejectDayOff,
        },
        {
            reactQueryKeys: QUERY_KEYS.DAYOFFS,
            errorMessage: 'something went wrong',
        }
    )

    const {
        control: controlFeedbackForm,
        handleSubmit: handleFeedback,
        formState: { errors: errorsReject },
        setValue: setLeadFormValue,
    } = useForm<DayOffReject>({
        defaultValues: {
            day_off_feedback: 'Reject',
        },
    })

    const onLeaderSubmit = async (dataReq: DayOffReject) => {
        try {
            await checkRequireActionRejectMutation({
                id: dayOff?.day_off_id || 0,
                feedback: {
                    day_off_feedback: dataReq?.day_off_feedback,
                },
            })
            toast.success('Reject success')
            onClose?.()
            refetch()
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (dayOff?.day_off_status === 'rejected') {
            setLeadFormValue('day_off_feedback', dayOff?.day_off_note)
        }
    }, [dayOff])

    return (
        <div className="w-full mb-2 border rounded shadow-md p-4 bg-gray-100">
            <Typogaphy className="font-bold text-gray-500 mb-2">
                Reject feedback
            </Typogaphy>
            <form onSubmit={handleFeedback(onLeaderSubmit)}>
                <Controller
                    control={controlFeedbackForm}
                    name="day_off_feedback"
                    rules={{
                        required: {
                            value: true,
                            message: 'Please feedback',
                        },
                    }}
                    render={({ field: { value, onChange } }) => {
                        return (
                            <>
                                <textarea
                                    disabled={
                                        ![
                                            'pending',
                                            'leader-approved',
                                        ].includes(dayOff?.day_off_status)
                                    }
                                    placeholder="BOD feedback confirm"
                                    className="w-full border border-gray-100 rounded-[8px] p-4 small focus:border-blue-500 focus:ring-1 focus:ring-blue-500 my-1"
                                    rows={4}
                                    value={value}
                                    onChange={onChange}
                                />
                                {!!errorsReject?.day_off_feedback && (
                                    <Typogaphy className="px-2 text-red-500">
                                        *
                                        {errorsReject?.day_off_feedback
                                            ? errorsReject?.day_off_feedback
                                                  ?.message
                                            : ''}
                                    </Typogaphy>
                                )}
                            </>
                        )
                    }}
                />
                <div className="w-full flex justify-end gap-2">
                    {onClose && (
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={onClose}
                        >
                            Cancel
                        </Button>
                    )}
                    <Button
                        type="submit"
                        disabled={
                            !['pending', 'leader-approved'].includes(
                                dayOff?.day_off_status
                            ) || isPendingRequireRejectAction
                        }
                    >
                        Confirm
                    </Button>
                </div>
            </form>
        </div>
    )
}

export const RejectForm = (props: DayOffFormProps) => {
    return <RejectFeedbackForm {...props} />
}
